// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Xw","fullWidth":"e_Yw"};